import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDepartmentDestroyMutation } from 'graphql-common';
import toast from '@lib/components/Toast/Toast';
import {
  Modals,
  UseModalManagementResult,
} from '@lib/hooks/useModalManagement';
import { APP_URLS } from 'constants/urls';

type Args = {
  useModalManagementResult: UseModalManagementResult;
};

export default function useDepartmentViewActions({
  useModalManagementResult,
}: Args) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id = '' } = useParams();
  const { closeModal, openModal } = useModalManagementResult;

  const [destroyMutation, destroyMutationResult] = useDepartmentDestroyMutation(
    {
      onCompleted: () => {
        closeModal(Modals.DepartmentDestroyModal);
        toast({ content: t('destroy-department-success') });
        navigate(APP_URLS.dashboard.departments.index.getPathWithQuery());
      },
      onError: (error) => {
        toast({ content: error.message || t('something-went-wrong') });
      },
    },
  );

  const onEdit = () =>
    navigate(
      APP_URLS.dashboard.departments.edit.getDynamicPath({
        pathParts: { id },
      }),
    );

  const onDelete = () => openModal(Modals.DepartmentDestroyModal);

  const onConfirmedDelete = () => {
    if (id) destroyMutation({ variables: { id } });
  };

  return {
    onEdit,
    onDelete,
    onConfirmedDelete,
    destroyLoading: destroyMutationResult.loading,
  };
}
